import { useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";

const MAX_TAG_LENGTH = 20;
const TAG_REGEX = /^[a-z0-9\s]+$/i;

const TagInput = ({className="", tags, setTags}) => {

    const [error, setError] = useState("");
    const inputRef = useRef();

    const addTag = (e) => {
        if(e.key === " " || e.key === "Enter") {
            e.preventDefault();
            const newTag = e.target.value.trim().toLowerCase();

            if (!newTag) {
                setError("The tag cannot be empty.");
            } else if (tags.includes(newTag)) {
                setError("The tag already exists");
            } else if (newTag.length > MAX_TAG_LENGTH) {
                setError(`Tags must be less than ${MAX_TAG_LENGTH} characters`);
            } else if (!TAG_REGEX.test(newTag)) {
                setError("Tags can only contain letters and numbers");
            } else {
                setTags([...tags, newTag]);
                setError("");
                e.target.value = "";
            }
        }
    }

    const removeTag = (removeIndex) => {
        setTags(prev => prev.filter((_, index) => (index !== removeIndex)));
        inputRef.current && inputRef.current.focus();
    }


    return (
        <Form.Group className={"d-flex flex-column "+className} controlId="tagBox">
            <Form.Label className="ms-3 text-white-50">Tags</Form.Label>
            <div className="d-flex flex-wrap gap-2 rounded">
                <ul className="list-group flex-row flex-wrap gap-2">
                    {tags.map((tag, index) => {
                        return (
                            <li className="d-flex justify-content-center align-items-center bg-darker" key={tag} >
                                <Button variant="primary" className="d-flex gap-2 justify-content-center align-items-center ps-2 pe-1 py-1" onClick={() => removeTag(index)} >
                                    <span className="fs-6">{tag}</span>
                                    <box-icon name='x-circle' size='sm' type='solid' color='white' ></box-icon>
                                </Button>
                            </li>
                        )
                    })}
                </ul>
                <Form.Control
                    ref={inputRef}
                    className="bg-darker border-0"
                    size="md"
                    type="text"
                    placeholder="Modernism, nature, portrait, ..."
                    onKeyDown={addTag}
                    disabled={tags.length >= 10}
                    aria-describedby="tags"
                />
            </div>
            {error && <div className="text-danger ms-2 mt-1">{error}</div>}
        </Form.Group>
    );
}

export default TagInput;